import {
    Button,
    InputBase,
    MenuItem,
    Select,
    SelectProps,
} from '@mui/material';
import { forwardRef } from 'react';

interface Option {
    value: string | number;
    label: string;
}

type SimpleSelectProps = SelectProps & {
    options: Option[];
};

const SimpleSelect = forwardRef<HTMLDivElement, SimpleSelectProps>(
    ({ options, ...props }, ref) => {
        return (
            <Select
                input={<InputBase />}
                slots={{
                    root: ({ onClick, sx, children, ownerState }) => (
                        <Button
                            onClick={onClick}
                            sx={{ ...sx, pr: 0 }}
                            variant="text"
                            color="inherit"
                        >
                            {children}
                        </Button>
                    ),
                }}
                {...props}
                ref={ref}
            >
                {options.map((option, index) => (
                    <MenuItem key={index} value={option.value}>
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
        );
    },
);

export default SimpleSelect;
